import React from 'react';
import '@/App.css';
import '@/index.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Landing } from './pages/Landing';
import { AuthCallback } from './pages/AuthCallback';
import { Subscription } from './pages/Subscription';
import { Dashboard } from './pages/Dashboard';
import { Registros } from './pages/Registros';
import { Conciliacao } from './pages/Conciliacao';
import { Metas } from './pages/Metas';
import { Assistente } from './pages/Assistente';
import { Perfil } from './pages/Perfil';
import { Assinatura } from './pages/Assinatura';
import { SessoesAtivas } from './pages/SessoesAtivas';
import { Notificacoes } from './pages/Notificacoes';
import { Gerenciar } from './pages/Gerenciar';
import { CarteirasMovimentacoes } from './pages/CarteirasMovimentacoes';
import { CarteirasContas } from './pages/CarteirasContas';

function AppRouter() {
  const location = useLocation();
  
  // CRITICAL: Check for session_id in URL fragment synchronously
  // This prevents race conditions with auth state checking
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth-callback" element={<AuthCallback />} />
      
      <Route
        path="/subscription"
        element={<Navigate to="/assinatura" replace />}
      />
      
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute requireSubscription>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/carteiras"
        element={<Navigate to="/carteiras/movimentacoes" replace />}
      />

      <Route
        path="/carteiras/movimentacoes"
        element={
          <ProtectedRoute requireSubscription>
            <CarteirasMovimentacoes />
          </ProtectedRoute>
        }
      />

      <Route
        path="/carteiras/bancos"
        element={<Navigate to="/carteiras/movimentacoes" replace />}
      />

      <Route
        path="/carteiras/contas"
        element={
          <ProtectedRoute requireSubscription>
            <CarteirasContas />
          </ProtectedRoute>
        }
      />

      <Route
        path="/carteiras/categorias"
        element={<Navigate to="/carteiras/contas" replace />}
      />

      <Route
        path="/registros"
        element={
          <ProtectedRoute requireSubscription>
            <Registros />
          </ProtectedRoute>
        }
      />

      <Route
        path="/conciliacao"
        element={
          <ProtectedRoute requireSubscription>
            <Conciliacao />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/metas"
        element={
          <ProtectedRoute requireSubscription>
            <Metas />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/assistente"
        element={
          <ProtectedRoute requireSubscription>
            <Assistente />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/perfil"
        element={
          <ProtectedRoute requireSubscription>
            <Perfil />
          </ProtectedRoute>
        }
      />

      <Route
        path="/assinatura"
        element={
          <ProtectedRoute requireSubscription>
            <Assinatura />
          </ProtectedRoute>
        }
      />

      <Route
        path="/sessoes-ativas"
        element={
          <ProtectedRoute requireSubscription>
            <SessoesAtivas />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/notificacoes"
        element={
          <ProtectedRoute requireSubscription>
            <Notificacoes />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/gerenciar"
        element={
          <ProtectedRoute requireSubscription>
            <Gerenciar />
          </ProtectedRoute>
        }
      />
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
